module.exports = __webpack_public_path__ + "img/logo.dc7a0b69.png";